import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const SEEK_INTERVAL = 10;
export const EMPTY_FRAGMENTS: SkippableFragment[] = [];
export const VOLUME_STEP = 10;
